<template>
    <div>
        <!-- show chart -->
        <app-chart :datasets="datasets"></app-chart>

        <div class="container-fluid">
            <div class="row">
                <div class="col-12 mt-5">
                    <p class="ml-3"><i class="fas fa-square-full text-dark-green"></i> Shop Views</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from './Chart.vue'

export default {
    name: "Views",
    data() {
        return {
            datasets: [
                {
                    data: [70, 100, 400, 180, 100, 300, 500],
                    smooth: true,
                    showPoints: true,
                    fill: true,
                    className: "curve1"
                }
            ]
        }
    },
    components: {
        appChart: Chart
    },
    mounted() {
        this.$router.push('?views').catch((e) => {})
    }
}
</script>